import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { OpenXAgentChip } from '../../shared/OpenXAgentChip.tsx';
import { OpenXAgentChipList, OpenXAgentTitledCard } from '../../shared/OpenXAgentTitledCard.tsx';

type MatchedSegmentInterestTagsProps = {
  tags: string[];
};

export const MatchedSegmentInterestTags = ({ tags }: MatchedSegmentInterestTagsProps) => {
  const { t } = useTranslation();

  return (
    <OpenXAgentTitledCard title={t('Interest Tags')}>
      <OpenXAgentChipList>
        {tags.map((tag, index) => (
          <Box component="li" key={tag} sx={{ display: 'flex', gap: 1 }}>
            {index > 0 ? (
              <OpenXAgentChip sx={{ backgroundColor: 'background.boxDark', color: 'text.disabled' }}>
                {t('OR')}
              </OpenXAgentChip>
            ) : null}

            <OpenXAgentChip data-test="openx-agent-matched-segment-interest-tag" sx={{ color: 'text.primary' }}>
              {tag}
            </OpenXAgentChip>
          </Box>
        ))}
      </OpenXAgentChipList>
    </OpenXAgentTitledCard>
  );
};
